import { useSpring } from '@react-spring/web';
import { transparentWhite } from "./constants";
import VARIABLES from "@theme/global/variables";

export const useAnimatedStick = (isStuck) => {
  
  const showDetachedButton = isStuck;
  const stuckSpring = useSpring({
    backgroundColor: showDetachedButton ? "rgba(255,255,255,1)" : transparentWhite,
    borderTopColor: showDetachedButton ? VARIABLES.COLORS.lightGrayFour : transparentWhite,
    from: {
      backgroundColor: transparentWhite,
      borderTopColor: transparentWhite,
    }
  });
  return stuckSpring;
};
